import { render, staticRenderFns } from "./Dependencies.vue?vue&type=template&id=5c252b9e&scoped=true&"
import script from "./Dependencies.vue?vue&type=script&lang=js&"
export * from "./Dependencies.vue?vue&type=script&lang=js&"
import style0 from "./Dependencies.vue?vue&type=style&index=0&id=5c252b9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c252b9e",
  null
  
)

export default component.exports